import services from 'api/services';
import { logError } from 'util/errors';

import { LOAD_STATISTICS_REQUEST, LOAD_STATISTICS_SUCCESS, LOAD_STATISTICS_FAILURE } from './constants';

const { StatisticsService } = services;

export const getStatistics =
  ({ minDate, maxDate, companyName }) =>
  async (dispatch) => {
    try {
      dispatch({ type: LOAD_STATISTICS_REQUEST });
      const statistics = await StatisticsService.getStatistics({ minDate, maxDate, companyName });
      dispatch({ type: LOAD_STATISTICS_SUCCESS, data: statistics });
    } catch (ex) {
      logError(ex);
      dispatch({ type: LOAD_STATISTICS_FAILURE, error: ex.message });
    }
  };
